import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";
import { makeArrayRandom } from "../../../../utils/learner";

export default function WebNumeracySelectFraction({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [availableChoices, setAvailableChoices] = useState(makeArrayRandom(data.choices));
    const [answer, setAnswer] = useState([]);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAvailableChoices(makeArrayRandom(data.choices));
        setAnswer([]);
    }, [question,
        data.choices,
    ]);

    const handleClickChoice = (choice) => {
        let ans = [...answer];
        if (!data.multiple) {
            ans = []; // reset for string
        }

        ans = [
            ...ans,
            choice.stateKey
        ];
        
        setAnswer(ans);
        checkCanProceed(ans);
    }

    const checkCanProceed = (ans) => {
        const canProceed = ans.length > 0;

        const finalAnswer = data.multiple ? ans : (ans[0] ?? "");

        onAnswer({
            canProceed,
            answer: finalAnswer,
        });
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center"
            }}
        >
            <Box component="img"
                src={`${imagesResources}${data.image}`}
                alt="Img"
            />

            <Box sx={{
                width: "500px",
                marginTop: "20px",
                justifyContent: "space-between",
                display: "flex",
                textAlign: "center"
            }}>
                {/* For Choices */}
                {availableChoices.map((choice, index) => (
                    <Box key={index} 
                        component="span"
                        sx={{
                            width: "80px",
                            // height: "100px",
                            padding: "4px 10px 4px 10px",
                            fontSize: "1.3em",
                            display: "inline-table",
                            cursor: "pointer",
                            userSelect: "none",
                            backgroundColor: answer.includes(choice.stateKey) ? "#afe23e" : "#dadada",
                            borderBottom: answer.includes(choice.stateKey) ? "10px solid #639729" : "10px solid #808080",
                            fontWeight: "bold",
                            textAlign: "center",
                        }}
                        onClick={() => {handleClickChoice(choice)}}
                    >
                        <Box component="span"
                            sx={{
                                display: "table-cell",
                                verticalAlign: "middle",
                                fontSize: "1.3em",
                                cursor: "pointer",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}
                        >{choice.value}</Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};